import { Component } from '@angular/core';
import { NavController, Events, IonicPage } from 'ionic-angular';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { CrudProvider } from '../../providers/crud/crud';
@IonicPage()
@Component({
  selector: 'page-cabsand-news',
  templateUrl: 'cabsand-news.html',
})
export class CabsandNewsPage {
  horizontalText: any = "";
  newsLiist: any = [];

  constructor(public navCtrl: NavController, public utility: UtiltiyProvider, private api: CrudProvider, public events: Events) {
    this.getNews();
    // this.navCtrl.swipeBackEnabled = false;
  }

  async getStatus() {
    this.horizontalText = ``;

  }

  getNews() {
    this.newsLiist = [];
    let string = "";
    this.api.get("/tansix_prestart/news/News_get", "false")
      .then((result: any) => {
        result.result.forEach(element => {
          string = string + `Subject: ${element.subject} Date: ${element.date} By:${element.username}     `

        });
        this.horizontalText = string;
        this.newsLiist = result.result;
        console.log("result", this.newsLiist)
        console.log("this.horizontalText ", this.horizontalText)
      }, err => {
      })
  }

  dateConvert(date) {

    if (date) {
      let dateString = date.split("-");
      return dateString[2] + "-" + dateString[1] + "-" + dateString[0]
    } else {
      return "";
    }

  }
}


// WEBPACK FOOTER //
// ./src/pages/cabsand-news/cabsand-news.ts